import { Grid, Theme, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { DifferenceProps } from '../DifferenceElementView';
import { useStyles as useDescriptionStyles } from '../DifferenceDescription/DifferenceDescription';

const useStyles = makeStyles()((theme: Theme) => {
  return {
    root: {
      width: '100%',
      padding: theme.spacing(1, 0),
    },
    message: {
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
    hint: {
      color: 'var(--gds-color-text-supportive)',
      marginTop: theme.spacing(0.5),
    },
  };
});

const ReadingOrderDifference = ({ difference }: DifferenceProps) => {
  const { classes } = useStyles();
  const { classes: descriptionClasses } = useDescriptionStyles();
  const sourcePage = difference.source.location.pageNumber;
  const targetPage = difference.target.location.pageNumber;

  return (
    <Grid container direction="column" className={classes.root} wrap="nowrap">
      <Typography variant="body1" className={classes.message}>
        Text has been moved in the new version.
      </Typography>
      <Grid item container wrap="nowrap" spacing={1}>
        <Grid item>
          <Typography className={`${descriptionClasses.pageDescription} ${descriptionClasses.differencePageNumber}`}>
            source (p{sourcePage})
          </Typography>
        </Grid>
        <Grid item>
          <Typography className={`${descriptionClasses.pageDescription} ${descriptionClasses.differencePageNumber}`}>
            new (p{targetPage})
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ReadingOrderDifference;
